import React from 'react';
import { useStore } from 'effector-react';
import type { HSIconImage, HSIconSeqFrame, HSIconVideo } from '@types';
import {
  $editingHotspot,
  $editingHotspotApi,
} from '@stores/editingHotspotStores';
import { MainPlayer } from '@stores/krpPlayerStores';
import WidgetRow from '@components/PlayerWidgets/WidgetRow';
import MoveBtn, { type Direction } from './MoveBtn';

const STEP = 0.05;

const paramsMap: Record<Direction, { key: 'ath' | 'atv'; step: number }> = {
  up: { key: 'atv', step: -STEP },
  right: { key: 'ath', step: STEP },
  down: { key: 'atv', step: STEP },
  left: { key: 'ath', step: -STEP },
};

function ImageMoveRow() {
  const { hotspot, isBatch, batchHotspots } = useStore($editingHotspot)!;

  const handleMoveClick = (direction: Direction) => {
    const { step, key } = paramsMap[direction];
    if (!isBatch) {
      const spot = MainPlayer.get()?.getHotspotById(hotspot.id);
      if (!spot) return;
      const newVal = spot[key] + step;
      $editingHotspotApi.update((draft) => {
        (draft.icon as HSIconImage | HSIconSeqFrame | HSIconVideo)[key] =
          newVal;
      });
      MainPlayer.get()?.updateHotspot({ id: hotspot.id, [key]: newVal });
    } else {
      const hotspots = $editingHotspot.getState()?.batchHotspots ?? [];
      if (hotspots) {
        hotspots.forEach((item) => {
          const newVal1 =
            (item.icon as HSIconImage | HSIconSeqFrame | HSIconVideo)[key] +
            step;
          (item.icon as HSIconImage | HSIconSeqFrame | HSIconVideo)[key] =
            newVal1;
        });
        $editingHotspotApi.updateBatch(hotspots);
      }
      (hotspots ?? []).forEach((item) => {
        const newVal2 =
          (item.icon as HSIconImage | HSIconSeqFrame | HSIconVideo)[key] + step;
        MainPlayer.get()?.updateHotspot({
          id: item.id,
          [key]: newVal2,
        });
      });
    }
  };

  return (
    <WidgetRow>
      <div className="mb-10">平移：</div>
      <div className="mb-2 flex justify-center text-black-gray">上移</div>
      <div className="mb-2 flex justify-center">
        <MoveBtn direction="up" onClick={handleMoveClick} />
      </div>
      <div className="flex justify-between text-black-gray">
        <div className="flex items-center">
          <div className="mr-5">左移</div>
          <MoveBtn direction="left" onClick={handleMoveClick} />
        </div>
        <div className="flex items-center">
          <MoveBtn direction="right" onClick={handleMoveClick} />
          <div className="ml-5">右移</div>
        </div>
      </div>
      <div className="mt-2 flex justify-center">
        <MoveBtn direction="down" onClick={handleMoveClick} />
      </div>
      <div className="mt-2 flex justify-center text-black-gray">下移</div>
    </WidgetRow>
  );
}

export default ImageMoveRow;
